import { Injectable, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { Dictionary } from '../models/dictionary.model';
import { APX_ERRORS_CONFIG } from '../form/config';

@Injectable({
    providedIn: 'root'
})
export class ControlErrorMessageService {
    private readonly errorMessages = inject<Dictionary<string>>(APX_ERRORS_CONFIG, { optional: true });

    mapError(errors: ValidationErrors | null) {
        if (this.errorMessages && errors) {
            const errorMessages = this.errorMessages;
            const errorKeys = Object.keys(errors);
            const keyProp = errorKeys.find(e => !!errorMessages[e]);
            if (keyProp !== undefined) {
                return errorMessages[keyProp];
            }
        }
        // If the error message does not exist in errorMessages, check for this specific structure and extract the message
        // {'errorKey': {errorMessage: 'This is an error message'}}
        if (errors) {
            for (const key in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, key)) {
                    const errorObject = errors[key];
                    if (errorObject && typeof errorObject === 'object' && 'errorMessage' in errorObject) {
                        return errorObject['errorMessage'];
                    }
                }
            }
        }

        return '';
    }
}
